module.exports = __webpack_public_path__ + "img/Published2.20e64865.png";